import { render, staticRenderFns } from "./components_backup.vue?vue&type=template&id=c06214d4&"
import script from "./components_backup.vue?vue&type=script&lang=js&"
export * from "./components_backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports